import { Formik } from "formik";
import { FC, SetStateAction, createContext, useEffect, useState } from "react";
import * as Yup from "yup";
import { getListWarehouse } from "../utils/ServicesUtils";
import FormXuatKho from "./components/FormXuatKho";

export interface PhanHeNhapKhoContextProps {
    dsNhapKho: any;
    setDsNhapKho: SetStateAction<any>;
    detailPhieuNhap: any;
    setDetailPhieuNhap: SetStateAction<any>;

}

const initialContext = {
    dsNhapKho: [],
    setDsNhapKho: () => { },
    detailPhieuNhap: [],
    setDetailPhieuNhap: () => { },
}

export const PhanHeNhapKhoContext = createContext<PhanHeNhapKhoContextProps>(initialContext)
interface Props {
    warehouseId: number;
    className?: any;
    typeKho?: any;
}
export const PhieuInXuatKho = (props: Props) => {
    const { warehouseId, typeKho, className } = props;
    const [dsNhapKho, setDsNhapKho] = useState([]);
    const [detailPhieuNhap, setDetailPhieuNhap] = useState({});
    const [lstWarehouse, setLstWarehouse] = useState<any>({});

    let validationSchema = Yup.object({});
    const handleFormSubmit = (values: any) => { }
    return (
        <Formik<any>
            initialValues={{}}
            validationSchema={validationSchema}
            onSubmit={handleFormSubmit}
        >
            <PhanHeNhapKhoContext.Provider
                value={{
                    dsNhapKho: dsNhapKho,
                    setDsNhapKho: setDsNhapKho,
                    detailPhieuNhap,
                    setDetailPhieuNhap,
                }}
            >
                <div className="bg-white">

                    <div className="flex-1 flex flex-column">
                        <div className="py-1">
                            <FormXuatKho
                                className={className}
                                LST_WAREHOUSE={lstWarehouse}
                                warehouseId={warehouseId || typeKho?.id}
                                typeKho={typeKho}
                            />
                        </div>
                    </div>


                </div>

            </PhanHeNhapKhoContext.Provider>
        </Formik>

    )
}

export default PhieuInXuatKho;
